import { Plus } from 'lucide-react';
import { LayoutCard } from './LayoutCard';

interface LayoutListProps {
  layouts: any[];
  onAdd: () => void;
  onUpdate: (id: string, updates: any) => void;
  onDelete: (id: string) => void;
  onImageUpload: (id: string, event: React.ChangeEvent<HTMLInputElement>) => void;
}

export function LayoutList({ layouts, onAdd, onUpdate, onDelete, onImageUpload }: LayoutListProps) {
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <h4 style={{ fontSize: '0.95rem', fontWeight: 600, color: '#00303c', margin: 0 }}>
          Mises en place configurées
        </h4>
        <button
          type="button"
          onClick={onAdd}
          style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem 1rem', background: '#00758d', color: 'white', border: 'none', borderRadius: '8px', fontSize: '0.85rem', fontWeight: 600, cursor: 'pointer', transition: 'all 0.2s ease' }}
          onMouseEnter={(e) => (e.currentTarget.style.background = '#00303c')}
          onMouseLeave={(e) => (e.currentTarget.style.background = '#00758d')}
        >
          <Plus size={16} /> Ajouter une mise en place
        </button>
      </div>

      {layouts.length === 0 ? (
        <div style={{ padding: '2rem', textAlign: 'center', background: '#f8fafb', border: '2px dashed #e5e7eb', borderRadius: '12px', color: '#6b7280' }}>
          Aucune mise en place configurée. Cliquez sur un template ou sur "Ajouter une mise en place".
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '1rem' }}>
          {layouts.map((layout) => (
            <LayoutCard
              key={layout.id}
              layout={layout}
              onUpdate={onUpdate}
              onDelete={onDelete}
              onImageUpload={onImageUpload}
            />
          ))}
        </div>
      )}
    </div>
  );
}
